import pathOr from 'ramda/src/pathOr'
import path from 'ramda/src/path'
import is from 'ramda/src/is'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (state, props) => {
	const { moduleKey, fieldDescPath } = props
	const fieldMod = path([moduleIdFromKey(moduleKey), ...fieldDescPath], moduleDescriptions)
	const fieldData = is(Function, fieldMod) ? fieldMod(state, props) : fieldMod
	return pathOr(
		'',
		['placeholder'],
		fieldData,
	)
}
